module.exports = __webpack_public_path__ + "img/trustpilot.c6d5c0da.svg";